import { HttpClient } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';


@Injectable({ providedIn: 'root' })
export class StorageService {
          

    constructor(
        private http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    private isBrowser(): boolean {
        return isPlatformBrowser(this.platformId);
    }


    saveStores(stores: any[]) : void{
        if (!this.isBrowser()) {
            return;
        }
        localStorage.setItem("stores", JSON.stringify(stores));
    }

    saveSelectedStore(store: any) : void{
        if (!this.isBrowser()) {
            return;
        }
        localStorage.removeItem('selectedStore');
        localStorage.setItem("selectedStore", JSON.stringify(store));
    }

    getStores() : any[] {
        if (!this.isBrowser()) {
            return [];
        }
        var storesStr = localStorage.getItem('stores');
        return (storesStr) ? JSON.parse(storesStr) : [];
    }

    getSelectedStore() : any {
        if (!this.isBrowser()) {
            return null;
        }
        var selectedStoreStr = localStorage.getItem('selectedStore');
        return (selectedStoreStr) ? JSON.parse(selectedStoreStr) : [];
    }

    removeStores(){
        if (!this.isBrowser()) {
            return;
        }
        localStorage.removeItem('stores');
    }

    removeSelectedStore(){
        if (!this.isBrowser()) {
            return;
        }
        localStorage.removeItem('selectedStore');
    }

    removeAll(){
        this.removeStores();
        this.removeSelectedStore();
    }
}
